module.exports = __webpack_public_path__ + "static/media/logo11.f0956af8.jpg";